<div class="active-asset-container">
    <div class="active-asset-card">
      <i class="fas fa-times-circle status-icon"></i>
      <h5 class="title">Asset Inactive</h5>
      <p class="message text-xs">
        This asset is currently inactive and not operational. Access to services and features
        is temporarily suspended.
      </p>
      <div class="additional-info text-xs">
        <p>
          If you need any assistance or have questions, please contact our support
          team.
        </p>
      </div>
      <div class="divider my-4">
          <span class="divider-text text-xs text-muted">or continue with</span>
      </div>
      <a href="/">
        <button
          type="button"
          class="btn btn-bg-green secondary-text-dark text-xs w-75 fw-bold mt-2"
        >
          Login
        </button>
      </a>
    </div>
  </div>